<template>
  <el-select
    :value="driver"
    @change="emitDriverUpdated($event)"
    remote
    filterable
    reserve-keyword
    value-key="id"
    :placeholder="placeholder"
    clearable
    :remote-method="handleDriverInfoInput"
  >
    <el-option
      v-for="item in options"
      :key="item.value.licenseNumber"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import longTermCareService from '@/API/longTermCareService'

const parseToOption = (licenseNumber) => ({
  label: licenseNumber,
  value: licenseNumber,
})

export default {
  props: {
    driver: {
      type: [String],
      default: function () {
        return ''
      },
    },
    placeholder: {
      type: String,
      default: '請輸入車牌號碼',
    },
    preferParams: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      availableDrivers: [],
      options: [],
    }
  },
  beforeUpdate() {
    if (this.driver && this.availableDrivers.length === 0) {
      this.options = [this.driver].map(parseToOption)
    }
  },
  methods: {
    emitDriverUpdated(licenseNumber) {
      this.$emit('driver-license-updated', licenseNumber)
    },
    handleDriverInfoInput(query) {
      const {
        service: { suv, wheelchair, highBackWheelchair } = {},
        searchFields = 'license_number',
      } = this.preferParams

      const { driver } = this
      const params = {
        suv,
        wheelchair,
        highBackWheelchair,
        [searchFields]: query,
      }

      longTermCareService
        .searchDriver(params)
        .then(({ result }) => {
          this.availableDrivers = result

          if (!result) return []
          return (
            result.length > 0 &&
            result.map((driver) => parseToOption(driver.licenseNumber))
          )
        })
        .then((result) => {
          this.options = result.filter((item) => {
            if (!item.label || !query) return false
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        })
        .catch(({ data: { error }, message }) => {
          this.options = []
          return this.$message.error(message || error.message)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/longTermCare/DriverLicenseSelector.vue